import { Image, Link, Stack, Text } from '@chakra-ui/react';
import React from 'react';
import notfound from '../assets/image/undraw_page_not_found.svg';
import { Link as RouterLink } from 'react-router-dom';

const Page404 = () => {
  return (
    <Stack>
      <Image src={notfound} />
      {/* <Link as={RouterLink} to="/">
        <Text color={'white'} as="span" ms="5px" fontSize={'xl'}>
          Go Back
        </Text>
      </Link> */}
    </Stack>
  );
};

export default Page404;
